import type { PlanogramItem } from "@CommonTypes/merchflow/pog/item";

export type PlanogramLabelOption = keyof PlanogramItem | "none";

export function resolvePlanogramProductLabel(
  product: unknown,
  labelField: PlanogramLabelOption,
  unavailableValue: string,
): string {
  if (labelField === "none") return "";
  if (!product || typeof product !== "object") return unavailableValue;

  const value: unknown = Reflect.get(product, labelField);
  if (typeof value === "string" && value.trim().length > 0) return value;
  // Numbers are rounded to at most 2 decimal places for display.
  if (typeof value === "number" && Number.isFinite(value)) return String(Number(value.toFixed(2)));

  return unavailableValue;
}
